import { observer } from 'mobx-react-lite'
import { Tooltip } from 'antd'
import './BaseFieldTemplate.css'

export const BaseFieldTemplate = observer(({ field, children }) => {
    if (field === undefined) return

    const error = field.formContext.getError(field.path)
    const fieldStyle = field.definition?.style ?? {}

    return (
        <div className={`form-field form-field-default ${field.error ? 'is-error' : ''}`} style={fieldStyle}>
            {field.label && (
                <label className="field-label" htmlFor={field.id}>
                    {field.isRequired && <span className="field-required">*</span>}
                    {field.label}
                    {field.tooltip && (
                        <Tooltip title={field.tooltip}>
                            <span className="field-info-icon">ⓘ</span>
                        </Tooltip>
                    )}
                </label>
            )}
            {children}
            {error && <small className="field-error">{error}</small>}
        </div>
    )
})
